// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/resource/v1/device.proto (package msh.resource.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3, Timestamp } from "@bufbuild/protobuf";
import { Agent } from "../../common/v1/common_pb";
import { RawStorageTrait } from "../../trait/sensor/v1/raw_storage_pb";
import { ThermalTrait_ThermalReading } from "../../trait/thermal/v1/thermal_pb";
import { BatteryPowerSourceTrait_Battery, BatteryPowerSourceTrait_PowerSource } from "../../trait/power/v1/battery_power_source_pb";
import { LoadTrait_Load } from "../../trait/load/v1/load_pb";

/**
 * @generated from message msh.resource.v1.Device
 */
export const Device = proto3.makeMessageType(
  "msh.resource.v1.Device",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "registry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "cloud_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "blocked", kind: "message", T: BoolValue },
    { no: 7, name: "creation_time", kind: "message", T: Timestamp },
    { no: 8, name: "created_by", kind: "message", T: Agent },
    { no: 9, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "raw_storage", kind: "message", T: RawStorageTrait },
    { no: 11, name: "cpu_thermal", kind: "message", T: ThermalTrait_ThermalReading },
    { no: 12, name: "battery", kind: "message", T: BatteryPowerSourceTrait_Battery },
    { no: 13, name: "power_source", kind: "message", T: BatteryPowerSourceTrait_PowerSource },
    { no: 14, name: "load", kind: "message", T: LoadTrait_Load },
    { no: 15, name: "iot_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "ota_incremental_version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 17, name: "app_version_code", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 18, name: "is_online", kind: "message", T: BoolValue },
    { no: 19, name: "online_last_updated", kind: "message", T: Timestamp },
    { no: 20, name: "battery_level_last_updated", kind: "message", T: Timestamp },
    { no: 21, name: "power_source_last_updated", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message msh.resource.v1.DeviceFilter
 */
export const DeviceFilter = proto3.makeMessageType(
  "msh.resource.v1.DeviceFilter",
  () => [
    { no: 1, name: "is_online", kind: "message", T: BoolValue },
  ],
);

